import { computed, ref, watch } from 'vue';

/**
 * Encapsula el estado UI del modal de pago de plazos.
 * La selección sigue viviendo en el composable de dominio; aquí sólo se deriva
 * el resumen visible y el ciclo de apertura/cierre del modal.
 *
 * @param {Object} options
 * @param {import('vue').Ref<Array>} options.items
 * @param {import('vue').Ref<Map>} options.detalleCache
 * @param {(itemId: number|string, plazoId: number|string) => boolean} options.isSelected
 * @param {import('vue').Ref<boolean>} options.loading
 * @param {import('vue').Ref<string|null>} options.error
 * @param {(payload: { plazoIds: Array, jetToken?: string, guardarTarjeta?: boolean }) => void} options.onConfirm
 */
export function usePlazosPaymentModal({
    items,
    detalleCache,
    isSelected,
    loading,
    error,
    onConfirm,
}) {
    const isOpen = ref(false);

    const selectedPlazos = computed(() => {
        const result = [];

        for (const item of items.value) {
            const detalle = detalleCache.value.get(item.id);
            if (!detalle?.plazos) continue;

            for (const plazo of detalle.plazos) {
                if (isSelected(item.id, plazo.id)) {
                    result.push(plazo);
                }
            }
        }

        return result;
    });

    const open = () => {
        isOpen.value = true;
    };

    const close = () => {
        if (loading.value) return;
        isOpen.value = false;
    };

    const confirm = payload => {
        onConfirm(payload);
    };

    let wasLoading = false;
    watch(
        loading,
        newValue => {
            if (wasLoading && !newValue && !error.value) {
                isOpen.value = false;
            }

            wasLoading = newValue;
        }
    );

    return {
        isOpen,
        selectedPlazos,
        open,
        close,
        confirm,
    };
}
